"use strict";

$(function () {
    const quantityInput = document.querySelector("#id_quantity");
    const container = document.querySelector("#form-container");
    const totalForms = document.querySelector("#id_serial_numbers-TOTAL_FORMS");

    function updateSerialNumberForms() {
        // Default quantity to 1 if the input is empty or invalid
        // This ensures at least one serial number form is shown by default,
        // preventing issues with zero forms being rendered.
        const quantity = parseInt(quantityInput.value) || 1;
        const currentForms = container.querySelectorAll(".serial-no-form").length;

        if (quantity > currentForms) {
            const firstForm = container.querySelector(".serial-no-form");
            if (!firstForm) return;

            for (let i = currentForms; i < quantity; i++) {
                const newForm = firstForm.cloneNode(true);
                newForm.innerHTML = newForm.innerHTML.replace(/serial_numbers-(\d+)-/g, `serial_numbers-${i}-`);

                newForm.querySelectorAll("input").forEach(input => input.value = "");

                container.appendChild(newForm);
            }
        } else if (quantity < currentForms) {
            for (let i = currentForms; i > quantity; i--) {
                container.lastChild.remove();
            }
        }

        totalForms.value = quantity;
    }

    quantityInput.addEventListener("input", updateSerialNumberForms);
});